var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloghousesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 58,
    viewBox: "0 0 74 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(-199 -561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    transform: "translate(199 561)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 58,
    rx: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 73,
    height: 57,
    rx: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "H",
    transform: "translate(222.624 603)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fontSize: 35,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloghousesmall);
export default __webpack_public_path__ + "static/media/bloghousesmall.c43bcd8d1504d54ee529f34445905e71.svg";
export { ForwardRef as ReactComponent };